import { bathroomLabel, bedroomLabel } from '../format/bedroom.js';
function toFiniteNumber(value) {
    if (typeof value === 'number')
        return Number.isFinite(value) ? value : null;
    if (typeof value === 'string' && value.trim() !== '') {
        const n = Number(value);
        return Number.isFinite(n) ? n : null;
    }
    return null;
}
/**
 * Mirrors ChatCard's rent derivation: net falls back to rent, then the unit's
 * previous listing rent; two prices show only when net is below gross.
 */
export function getTourFeedbackPriceDisplay(unit) {
    const activeListing = unit.activeListing ?? null;
    const gross = toFiniteNumber(activeListing?.grossRent);
    const net = toFiniteNumber(activeListing?.netRent ?? activeListing?.rent ?? unit.previousListingRent);
    return {
        hasActiveListing: Boolean(activeListing),
        showTwoPrices: gross != null && net != null && net < gross,
        net,
        gross,
    };
}
/**
 * First usable thumbnail URL for the unit, preferring smaller variants since
 * the card renders a small thumbnail. Null when the unit has no images.
 */
export function getTourFeedbackImageUrl(unit) {
    const image = unit.images?.[0];
    if (!image)
        return null;
    return image.imageS || image.imageM || image.url || image.imageL || image.imageXs || null;
}
/** "2 beds, 2 baths" style label. Null when the unit has no bed/bath info. */
export function getTourFeedbackBedsBaths(unit) {
    if (typeof unit.numBedrooms !== 'number' && typeof unit.numBathrooms !== 'number') {
        return null;
    }
    const beds = bedroomLabel(unit.numBedrooms ?? 0);
    const baths = bathroomLabel(unit.numBathrooms ?? 0, unit.numHalfBathrooms ?? 0);
    return `${beds}, ${baths}`;
}
